import React from 'react'
import ProgressCardSkeleton from './ProgressCardSkeleton'
import MySkeletonGrid from './MySkeletonGrid'
import { Grid, Box, Skeleton } from '@mui/material'
import useBreakpoints from '../../../utils/Breakpoints'

function SkeletonPage() {
    const { isSm, isMd } = useBreakpoints()

    const chartGridItems = isSm
        ? [{ xs: 12 }, { xs: 12 }, { xs: 12 }, { xs: 12 }]
        : isMd
            ? [{ xs: 12 }, { xs: 8 }, { xs: 4 }, { xs: 6 }, { xs: 6 }, { xs: 12 }]
            : [
                { xs: 12 },
                { xs: 8 },
                { xs: 4 },
                { xs: 6 },
                { xs: 6 },
                { xs: 6 },
                { xs: 6 },
                { xs: 4 },
                { xs: 8 },
                { xs: 12 }
            ]

    const progressGridItems = isSm
        ? Array.from({ length: 4 }, () => ({ xs: 6 }))
        : isMd
            ? Array.from({ length: 6 }, () => ({ xs: 4 }))
            : Array.from({ length: 12 }, () => ({ xs: 2 }))


    return (
        <Box sx={{ padding: '20px' }}>
            {/* Progress Cards Section */}
            <Box sx={{ marginBottom: '30px' }}>

                <Skeleton variant="rectangular" animation="wave" height={'30px'} width={'100%'} sx={{ background: '#e2e8f0', borderTopLeftRadius: "10px", borderTopRightRadius: "10px", marginBottom: '6px' }} />

                <Grid container spacing={2}>
                    {progressGridItems.map((item, index) => (
                        <Grid item xs={item.xs} key={index}>
                            <ProgressCardSkeleton />
                        </Grid>
                    ))}
                </Grid>
            </Box>

            {/* Charts Section */}
            <Box>

                <MySkeletonGrid gridArray={chartGridItems} />


            </Box>
        </Box>
    )
}

export default SkeletonPage